import styles from '../styles/MessageBubble.module.scss';

interface ButtonProps {
    label: string;
    positionTop: boolean;
    text: string;
    textHeight: string;
    textIsMaxSize: boolean;
    bitTitle: boolean;
    noMargin?: boolean;
    topFull?: boolean;
    offsetTop?: number;
}

const MessageBubble: React.FC<ButtonProps> = ({ label, positionTop, text, textHeight, textIsMaxSize, bitTitle, noMargin = false, topFull = false, offsetTop = 0  }) =>  {
    const contentStyle = {
        height: textHeight,
        ...(noMargin && { maxHeight: '100%' }),
        ...((textIsMaxSize && textHeight==="auto") && { height: '100%' }),
    };

    const containerStyle = {
        ...(!textIsMaxSize && { maxHeight: '1000px' }),
        ...(textIsMaxSize && {
            maxHeight: `calc(100% - 125px - ${offsetTop}px)`,
            overflowy: 'scroll',
            height: 'auto'
        }),
        ...(topFull && { width: 'calc(100% - 32px)' }),
        ...(offsetTop > 0 && { marginTop: `${offsetTop}px` }),
    };

    return (
        <div className={positionTop ? styles.MessageTop : styles.Message } style={containerStyle}>
            <b className={bitTitle ? styles.bigTitle : ''} style={bitTitle ? {textAlign: 'center'} : {}}>{label}</b>
            {bitTitle ?
                <div className={textIsMaxSize ? styles.scrollableBlockBig : ''} dangerouslySetInnerHTML={{ __html: text }} style={contentStyle} />
                :
                <>
                    {label ==="" ?
                        <div className={textIsMaxSize ? styles.scrollableBlock : ''} dangerouslySetInnerHTML={{ __html: text }} style={contentStyle && {"maxHeight": textHeight}} />
                    :
                        <div className={textIsMaxSize ? styles.scrollableBlock : ''} dangerouslySetInnerHTML={{ __html: text }} style={contentStyle} />
                    }
                </>
            }
        </div>
    );
}


export default MessageBubble;
